module.exports = __webpack_public_path__ + "static/media/hatradolhetsz.2eb0457b.png";